import { render } from "./AppSpinner.vue?vue&type=template&id=9ee9739e"
import script from "./AppSpinner.vue?vue&type=script&lang=js"
export * from "./AppSpinner.vue?vue&type=script&lang=js"
script.render = render

export default script